import Nullstack from 'nullstack';
export default function IconWashMachine({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wash-machine",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "3",
    width: "14",
    height: "18",
    rx: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "14",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M8 6h.01"
  }), "   ", Nullstack.element("path", {
    d: "M11 6h.01"
  }), "   ", Nullstack.element("path", {
    d: "M14 6h2"
  }), "   ", Nullstack.element("path", {
    d: "M8 14c1.333 -.667 2.667 -.667 4 0c1.333 .667 2.667 .667 4 0"
  }), " ");
}